/**
 * @deprecated
 */
export const columnChart_yAxis = {
  type: "value",
  name: "",
  nameLocation: "center",
  nameTextStyle: {
    color: "#666666",
    fontSize: 12,
  },
  nameGap: 45,
  axisLine: {
    show: false,
  },
  min: function (value) {
    if (value.min % 10 !== 0) {
      return Math.floor(value.min / 10) * 10;
    } else {
      return value.min;
    }
  },
  label: {
    show: true,
  },
  axisTick: {
    show: false,
    length: 10,
  },
  axisLabel: {
    fontSize: 11,
    color: "#666666",
  },
  splitLine: {
    lineStyle: {
      color: "#e6e6e6",
    },
  },
};
/**
 * @deprecated
 */
export const barChart_yAxis = {
  type: "category",
  axisTick: {
    show: false,
  },
  axisLine: {
    lineStyle: {
      color: "#ccd6eb",
    },
  },
  axisLabel: {
    fontSize: 11,
    color: "#666666",
  },
  data: [],
};
/**
 * y轴值轴
 * @param style 
 * @param yAxisName 
 * @param yNameGap 
 */
export const getYaxisOfValue = function (
  style: any,
  yAxisName: string = "",
  yNameGap: number = 30
) {
  let paramJsonObj = [
    {
      name: yAxisName,
      nameTextStyle: {
        fontSize: style.fontSize,
        color: "#666666",
      },
      type: "value",
      nameGap: yNameGap,
      nameLocation: "middle",
      // Y轴线设置
      axisLine: {
        show: false,
        lineStyle: {
          opacity: 0.2,
        },
      },
      // Y轴线刻度设置
      axisTick: {
        show: false,
        length: 3,
        lineStyle: {
          opacity: 0.3,
        },
      },
      // Y轴线标签设置
      axisLabel: {
        show: true,
        color: "#666",
        fontSize: style.fontSize - 1,
      },
      splitLine: {
        show: true,
        lineStyle: {
          opacity: 0.6,
        },
      },
      // Y轴值域动态设置
      // max: function (value) {
      //   if (value.max % 10 !== 0) {
      //     return Math.ceil(value.max / 10) * 10;
      //   } else {
      //     return value.max;
      //   }
      // },
      min: function (value) {
        if (value.min % 10 !== 0) {
          return Math.floor(value.min / 10) * 10;
        } else {
          return value.min;
        }
      },
    },
  ];
  return paramJsonObj;
};
/**
 * 获取默认Y轴值轴 (废弃)
 * @param style 
 * @deprecated
 */
export const getYaxisOfValueDefault = (style) => {
  let paramJsonObj = [
    {
      name: "",
      nameTextStyle: {
        fontSize: style.fontSize,
        color: "#666666",
      },
      type: "value",
      nameLocation: "middle",
      // Y轴线设置
      axisLine: {
        show: false,
        lineStyle: {
          opacity: 0.2,
        },
      },
      // Y轴线刻度设置
      axisTick: {
        show: false,
        length: 3,
        lineStyle: {
          opacity: 0.3,
        },
      },
      // Y轴线标签设置
      axisLabel: {
        show: true,
        fontSize: style.fontSize,
      },
      splitLine: {
        show: true,
        lineStyle: {
          opacity: 0.6,
        },
      },
      // Y轴值域动态设置
      // max: function (value) {
      //   if (value.max % 10 !== 0) {
      //     return Math.ceil(value.max / 10) * 10;
      //   } else {
      //     return value.max;
      //   }
      // },
      min: function (value) {
        if (value.min % 10 !== 0) {
          return Math.floor(value.min / 10) * 10;
        } else {
          return value.min;
        }
      },
    },
  ];
  return paramJsonObj;
};

export const getYaxisOfValueTranlation = function (
  style: any,
  yAxisName: string = '',
  yNameGap: number = 30,
  tranclationnumber: number = 0
) {
  let paramJsonObj = [
    {
      name: yAxisName,
      nameTextStyle: {
        fontSize: style.fontSize,
        color: "#666666",
      },
      type: "value",
      nameGap: yNameGap,
      nameLocation: "middle",
      // Y轴线设置
      axisLine: {
        show: false,
        lineStyle: {
          opacity: 0.2,
        },
      },
      // Y轴线刻度设置
      axisTick: {
        show: false,
        length: 3,
        lineStyle: {
          opacity: 0.3,
        },
      },
      // Y轴线标签设置
      axisLabel: {
        show: true,
        fontSize: style.fontSize - 1,
        color: "#666",
        formatter: function (param) {
          return param + tranclationnumber;
        },
      },
      splitLine: {
        show: true,
        lineStyle: {
          opacity: 0.6,
        },
      },
      // Y轴值域动态设置
      // max: function (value) {
      //   if (value.max % 10 !== 0) {
      //     return Math.ceil(value.max / 10) * 10;
      //   } else {
      //     return value.max;
      //   }
      // },
      min: function (value) {
        if (value.min % 10 !== 0) {
          return Math.floor(value.min / 10) * 10;
        } else {
          return value.min;
        }
      },
    },
  ];
  return paramJsonObj;
};
/**
 * 获取Y轴转换值 -值轴（废弃）
 * @param style 
 * @deprecated
 */
export const getYaxisOfValueTranlationDefault = function (style: any) {
  let paramJsonObj = [
    {
      name: "",
      nameTextStyle: {
        fontSize: style.fontSize,
        color: "#666666",
      },
      type: "value",
      nameGap: 30,
      nameLocation: "middle",
      // Y轴线设置
      axisLine: {
        show: false,
        lineStyle: {
          opacity: 0.2,
        },
      },
      // Y轴线刻度设置
      axisTick: {
        show: false,
        length: 3,
        lineStyle: {
          opacity: 0.3,
        },
      },
      // Y轴线标签设置
      axisLabel: {
        show: true,
        fontSize: style.fontSize,
        // formatter: function (param) {
        //     return param + tranclationnumber;
        // }
      },
      splitLine: {
        show: true,
        lineStyle: {
          opacity: 0.6,
        },
      },
      // Y轴值域动态设置
      // max: function (value) {
      //   if (value.max % 10 !== 0) {
      //     return Math.ceil(value.max / 10) * 10;
      //   } else {
      //     return value.max;
      //   }
      // },
      min: function (value) {
        if (value.min % 10 !== 0) {
          return Math.floor(value.min / 10) * 10;
        } else {
          return value.min;
        }
      },
    },
  ];
  return paramJsonObj;
};
/**
 * 获取Y轴类目轴
 * @param style 
 * @param data 
 * @param yAxisName 
 */
export function getCategoryYAxis(
  style,
  data: string[] | string[][] = [],
  yAxisName: string = ""
) {
  const categoryAxis = [{
    type: "category",
    name: yAxisName,
    nameLocation: "center",
    nameTextStyle: {
      color: "#666666",
      fontSize: style.fontSize,
    },
    nameGap: 40,
    axisTick: {
      show: false,
    },
    axisLine: {
      lineStyle: {
        color: "#ccd6ed",
      },
    },
    axisLabel: {
      fontSize: style.fontSize - 1,
      color: "#666",
    },
    data: data,
  }];
  return categoryAxis;
}
/**
 * 获取Y轴值轴 （废弃）
 * @param style 
 * @param axisName 
 * @deprecated
 */
export function getValueYAxis(style, axisName: string = "") {
  const valueAxis = {
    type: "value",
    name: axisName,
    nameLocation: "center",
    nameTextStyle: {
      color: "#666666",
      fontSize: style.fontSize - 1,
    },
    nameGap: 30,
    axisLine: {
      show: false,
    },
    // max: function (value) {
    //   if (value.max % 10 !== 0) {
    //     return Math.ceil(value.max / 10) * 10;
    //   } else {
    //     return value.max;
    //   }
    // },
    min: function (value) {
      if (value.min % 10 !== 0) {
        return Math.floor(value.min / 10) * 10;
      } else {
        return value.min;
      }
    },
    label: {
      show: true,
    },
    axisTick: {
      show: false,
      length: 10,
    },
    axisLabel: {
      fontSize: style.fontSize - 1,
      color: "#666666",
    },
    splitLine: {
      lineStyle: {
        color: "#e6e6e6",
      },
    },
  };
  return valueAxis;
}
/**
 * 双Y轴-值轴
 * @param style 
 * @param axisName 
 */
export function getDoubleValueYAxis(style, axisName: string = "") {
  const valueAxis = [
    {
      type: "value",
      name: axisName,
      nameLocation: "center",
      nameTextStyle: {
        color: "#666666",
        fontSize: style.fontSize - 1,
      },
      nameGap: 30,
      axisLine: {
        show: false,
      },
      min: function (value) {
        if (value.min % 10 !== 0) {
          return Math.floor(value.min / 10) * 10;
        } else {
          return value.min;
        }
      },
      label: {
        show: true,
      },
      axisTick: {
        show: false,
        length: 10,
      },
      axisLabel: {
        fontSize: style.fontSize - 1,
        color: "#666666",
      },
      splitLine: {
        lineStyle: {
          color: "#e6e6e6",
        },
      },
    },
    {
      type: "value",
      name: axisName,
      nameLocation: "center",
      nameTextStyle: {
        color: "#666666",
        fontSize: style.fontSize - 1,
      },
      nameGap: 30,
      axisLine: {
        show: false,
      },
      min: function (value) {
        if (value.min % 10 !== 0) {
          return Math.floor(value.min / 10) * 10;
        } else {
          return value.min;
        }
      },
      label: {
        show: true,
      },
      axisTick: {
        show: false,
        length: 10,
      },
      axisLabel: {
        fontSize: style.fontSize - 1,
        color: "#666666",
      },
      splitLine: {
        lineStyle: {
          color: "#e6e6e6",
        },
      },
    },
  ];
  return valueAxis;
}

/**
 * 获取y轴双类目轴
 * @param style 
 * @param data 
 */
export function getDoubleCategoryYAxis(style, data: string[][] = [[], []]) {
  const categoryAxis = [
    {
      type: "category",
      nameLocation: "center",
      nameTextStyle: {
        color: "#666666",
        fontSize: style.fontSize,
      },
      nameGap: 30,
      inverse: true,
      axisTick: {
        show: false,
      },
      axisLine: {
        lineStyle: {
          color: "#ccd6ed",
        },
      },
      axisLabel: {
        fontSize: style.fontSize - 1,
        color: "#666",
      },
      data: data[0],
    },
    {
      type: "category",
      nameLocation: "center",
      nameTextStyle: {
        color: "#666666",
        fontSize: style.fontSize - 1,
      },
      nameGap: 30,
      inverse: true,
      axisTick: {
        show: false,
      },
      axisLine: {
        lineStyle: {
          color: "#ccd6ed",
        },
      },
      axisLabel: {
        fontSize: style.fontSize - 1,
        color: "#666",
      },
      data: data[1],
    },
  ];

  if (!data) {
    categoryAxis[0].data = []
    categoryAxis[1].data = []
  }
  return categoryAxis
}

//todo 声学分析图y
export function getYaxisOfNoiseAnalysisLine(categories) {
  const yAxis = [
    {
      name: 'noise level(dB)',
      nameLocation: 'middle',
      nameGap: 30,
      scale: true,
      type: 'value',
      splitNumber: 2,
      axisLabel: {
        rotate: 0,
        fontSize: '100%',
        formatter: function (data) {
          let valueText = '';
          if (data.length > 5) {
            valueText = data.substring(0, 5) + '...'
          } else {
            valueText = data
          }
          return valueText;
        }
      },
      axisTick: { show: false },
      splitLine: { show: true },
    },
    {
      axisTick: { show: false },
      splitLine: { show: true, interval: 0 },
      gridIndex: 1,
      data: categories
    },
    {
      gridIndex: 1,
    },
    {
      show: false,
      gridIndex: 0,
    }
  ]

  return yAxis
}

//todo 声学分析图y
export function getYaxisOfNoiseDropLine(yAxisName) {
  let paramJsonObj = [
    {
      name: yAxisName,
      // splitNumber: 3,
      nameTextStyle: {
        fontSize: "100%",
        color: "#666666",
      },
      type: "value",
      nameGap: '30',
      // scale: true,
      nameLocation: "middle",
      // Y轴线设置
      axisLine: {
        show: false,
        lineStyle: {
          opacity: 0.2,
        },
      },
      // Y轴线刻度设置
      axisTick: {
        show: false,
        length: 3,
        lineStyle: {
          opacity: 0.3,
        },
      },
      // Y轴线标签设置
      axisLabel: {
        show: true,
        rotate: 0,
        color: "#666",
        fontSize: '100%'
      },
      splitLine: {
        show: true,
        lineStyle: {
          opacity: 0.6,
        },
      },
      // Y轴值域动态设置
      // max: function (value) {
      //   if (value.max % 10 !== 0) {
      //     return Math.ceil(value.max / 10) * 10;
      //   } else {
      //     return value.max;
      //   }
      // },
      min: function (value) {
        if (value.min % 10 !== 0) {
          return Math.floor(value.min / 10) * 10;
        } else {
          return value.min;
        }
      },
    },
  ];
  return paramJsonObj;
};

/**
 * y轴值轴
 * @param style 
 * @param yAxisName 
 * @param yNameGap 
 */
export const getDefaultYaxisOfValue = function (style: any) {
  let paramJsonObj =
  {
    name: "",
    nameTextStyle: {
      fontSize: style.fontSize,
      color: "#666666",
    },
    type: "value" as 'value' | 'category' | 'time' | 'log',
    nameGap: 30,
    nameLocation: "middle" as 'center' | 'middle' | 'start' | 'end',
    // Y轴线设置
    axisLine: {
      show: false,
      lineStyle: {
        opacity: 0.2,
      },
    },
    // Y轴线刻度设置
    axisTick: {
      show: false,
      length: 3,
      lineStyle: {
        opacity: 0.3,
      },
    },
    // Y轴线标签设置
    axisLabel: {
      show: true,
      color: "#666",
      fontSize: style.fontSize - 1,
    },
    splitLine: {
      show: true,
      lineStyle: {
        opacity: 0.6,
      },
    },
    minInterval: 1,
    // Y轴值域动态设置
    // max: function (value) {
    //   if (value.max % 10 !== 0) {
    //     return Math.ceil(value.max / 10) * 10;
    //   } else {
    //     return value.max;
    //   }
    // },
    min: function (value) {
      if (value.min % 10 !== 0) {
        return Math.floor(value.min / 10) * 10;
      } else {
        return value.min;
      }
    },
  };
  return paramJsonObj;
};

export const getDefaultYaxisOfCategory = function (style: any) {
  let paramJsonObj =
  {
    name: "",
    nameTextStyle: {
      fontSize: style.fontSize,
      color: "#666666",
    },
    type: "category" as 'value' | 'category' | 'time' | 'log',
    nameGap: 30,
    nameLocation: "middle" as 'center' | 'middle' | 'start' | 'end',
    // Y轴线设置
    axisLine: {
      show: true,
      lineStyle: {
        opacity: 0.2,
      },
    },
    // Y轴线刻度设置
    axisTick: {
      show: true,
      length: 3,
      lineStyle: {
        opacity: 0.3,
      },
    },
    // Y轴线标签设置
    axisLabel: {
      show: true,
      color: "#666",
      fontSize: style.fontSize - 1,
    },
    splitLine: {
      show: true,
      lineStyle: {
        opacity: 0.6,
      },
    },
    // minInterval: 1,
    // Y轴值域动态设置
    // max: function (value) {
    //   if (value.max % 10 !== 0) {
    //     return Math.ceil(value.max / 10) * 10;
    //   } else {
    //     return value.max;
    //   }
    // },
    min: function (value) {
      if (value.min % 10 !== 0) {
        return Math.floor(value.min / 10) * 10;
      } else {
        return value.min;
      }
    },
  };
  return paramJsonObj;
}

/**
 * 简单Y轴值轴（只有最大值最小值）
 * @param style 
 */
export const getSimplifyYAxisOfValue = (style: any) => {
  let paramJsonObj =
  {
    name: "",
    nameTextStyle: {
      fontSize: style.fontSize,
      color: "#666666",
    },
    type: "value",
    nameGap: 30,
    nameLocation: "middle",
    interval: 999999,
    // Y轴线设置
    axisLine: {
      show: false,
      onZero: true,
      lineStyle: {
        opacity: 0.2,
      },
    },
    // Y轴线刻度设置
    axisTick: {
      show: false,
      length: 3,
      lineStyle: {
        opacity: 0.3,
      },
    },
    // Y轴线标签设置
    axisLabel: {
      show: true,
      color: "#666",
      fontSize: style.fontSize - 1,
    },
    splitLine: {
      show: true,
      lineStyle: {
        opacity: 0.6,
      },
    },
    // Y轴值域动态设置
    // max: function (value) {
    //   let maxTick = 0;
    //   if (!isNaN(value.max)) {
    //     maxTick = value.max == 0 ? 100 : value.max;

    //     maxTick = maxTick + (5 - (maxTick % 5));
    //   } else {
    //     maxTick = 100;
    //   }
    //   console.log(maxTick)
    //   return maxTick;
    // },
    max: function (value) {
      if (value.max % 10 !== 0) {
        return Math.ceil(value.max / 10) * 10;
      } else {
        return value.max;
      }
    },
    // min: function (value) {
    //   let minTick = 0;
    //   if (!isNaN(value.min)) {
    //     minTick = value.min;
    //     minTick -= (minTick % 5);
    //     minTick = minTick < 0 ? 0 : minTick;
    //   }
    //   console.log(minTick)
    //   return minTick;
    // },
    min: function (value) {
      if (value.min % 10 !== 0) {
        return Math.floor(value.min / 10) * 10;
      } else {
        return value.min;
      }
    },
  };
  return paramJsonObj;
}